import { ChevronDownIcon } from '@primer/octicons-react';
import { Button, SelectPanel } from '@primer/react';
import { useMemo, useState } from 'react';
import { useCommonContext } from '../../contexts/common';
import { useMonths } from '../../hooks/useMonths';

interface ISelectBoxThangProps {
    selectedValue: number;
    onSelectionChanged: (thangId: number) => void;
    maxWidth?: number;
}

const SelectBoxThang = (props: ISelectBoxThangProps) => {
    const { translate } = useCommonContext();
    const { thangs } = useMonths();
    const [open, setOpen] = useState(false);
    const [filter, setFilter] = useState('');

    const dataSource = useMemo(() => {
        return thangs.map(x => ({
            id: x.id,
            text: translate(x.thang),
            originalText: x.thang,
        }));
    }, [thangs, translate]);

    const filteredData = useMemo(() => {
        return dataSource.filter(item =>
            item.originalText.toLowerCase().includes(filter.toLowerCase())
        );
    }, [dataSource, filter]);

    const selectedData = useMemo(() => {
        return dataSource.find(item => item.id === props.selectedValue);
    }, [props.selectedValue, dataSource]);

    return (
        <SelectPanel
            renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
                <Button
                    sx={{
                        maxWidth: props.maxWidth ?? 200,
                    }}
                    trailingAction={ChevronDownIcon}
                    aria-labelledby={` ${ariaLabelledBy}`}
                    {...anchorProps}
                >
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {selectedData ? selectedData.text : translate(`Chọn tháng`)}
                    </span>
                </Button>
            )}
            title={translate(`Chọn tháng`)}
            placeholderText={translate("Search")}
            open={open}
            onOpenChange={setOpen}
            items={filteredData}
            selected={selectedData}
            onSelectedChange={(data: any) => {
                if (data) {
                    props.onSelectionChanged(data.id);
                    setOpen(false);
                }
            }}
            onFilterChange={setFilter}
            showItemDividers={true}
            overlayProps={{ width: 'small', height: 'medium' }}
        />
    );
};

export default SelectBoxThang;
